<template>
  <div>
    <video id="videoId" ref="videoPlayer" class="video-js vjs-big-play-centered"></video>
  </div>
</template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-youtube/dist/Youtube.js";

export default {
  name: "VideoPlayer",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      player: null
    };
  },

   mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.value,
      function onPlayerReady() {
        // console.log("onPlayerReady", this);
      }
    );
  },

  beforeDestroy() {
    // if (this.player) {
    //   this.player.dispose();
    // }
  }
};
</script>
